<template>
    <div class="admission-result-container">
        <div class="main-content">
            <h2 class="title">录取结果</h2>

            <div v-if="loading" class="loading">加载中...</div>

            <div v-else-if="result" class="result-section">
                <div class="result-card">
                    <div class="result-row">
                        <span class="label">姓 名：</span>
                        <span class="value underline">{{ result.XM }}</span>
                    </div>
                    <div class="result-row">
                        <span class="label">考生号：</span>
                        <span class="value">{{ result.KSH }}</span>
                    </div>
                    <div class="result-row">
                        <span class="label">省 份：</span>
                        <span class="value underline">{{ result.G_Sheng }}</span>
                    </div>
                    <div class="result-row">
                        <span class="label">身份证号：</span>
                        <span class="value">{{ result.ZJHM }}</span>
                    </div>
                    <div class="result-row">
                        <span class="label">考生成绩：</span>
                        <span class="value">{{ formatScore(result.TDCJ) }}</span>
                    </div>
                    <div class="result-row">
                        <span class="label">EMS单号：</span>
                        <span class="value">{{ result.G_EMSNO }}</span>
                    </div>
                    <div class="result-row">
                        <span class="label">快递查询：</span>
                        <span class="express-link" @click="queryExpress" v-if="result.G_EMSNO">点击进入查询</span>
                        <span class="value" v-else>暂无快递信息</span>
                    </div>

                    <div class="admission-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>录取学院</th>
                                    <th>专业名称</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ result.G_XYMC }}</td>
                                    <td>{{ result.ZYMC }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="back-btn-container">
                    <button @click="goBack" class="back-btn">返回查询</button>
                </div>
            </div>

            <div v-else-if="!isValid" class="invalid-access">
                <div class="invalid-icon">
                    <i class="el-icon-error"></i>
                </div>
                <h3>访问被拒绝</h3>
                <p>无效的访问参数，请联系管理员获取正确的访问链接</p>
            </div>
            <div v-else class="not-found-section">
                <div class="not-found-icon">
                    <i class="el-icon-warning"></i>
                </div>
                <h3>未查询到录取信息</h3>
                <p>请检查您输入的姓名和身份证号是否正确</p>
                <button @click="goBack" class="back-btn">返回查询</button>
            </div>
        </div>

        <div v-if="telDialogVisible" class="express-dialog">
            <div class="express-dialog-mask" @click="closeTelDialog"></div>
            <div class="express-dialog-content">
                <div class="dialog-header">
                    <h3>输入手机号后4位</h3>
                    <span class="close-btn" @click="closeTelDialog">×</span>
                </div>
                <div class="dialog-body">
                    <div class="tel-input-section">
                        <p class="tel-hint">查询顺丰快递需要输入收件人手机号后4位</p>
                        <el-input 
                            v-model="telInput" 
                            placeholder="请输入4位数字" 
                            maxlength="4" 
                            @keyup.enter.native="confirmTelInput"
                            @keydown.enter.native="confirmTelInput"
                            class="tel-input">
                        </el-input>
                        <div class="dialog-actions">
                            <button @click="closeTelDialog" class="cancel-btn">取消</button>
                            <button @click="confirmTelInput" class="confirm-btn">确定</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="expressDialogVisible" class="express-dialog">
            <div class="express-dialog-mask" @click="closeExpressDialog"></div>
            <div class="express-dialog-content">
                <div class="dialog-header">
                    <h3>物流信息查询</h3>
                    <span class="close-btn" @click="closeExpressDialog">×</span>
                </div>
                <div class="dialog-body">
                    <div v-if="loadingExpress" class="loading">加载中...</div>
                    <div v-else-if="expressInfo">
                        <div class="ems-no">EMS单号：{{ expressInfo.EmsNo }}</div>
                        <div class="express-status" :class="expressInfo.Status">
                            {{ getStatusText(expressInfo.Status) }}
                        </div>
                        <div class="express-timeline">
                            <div v-for="(item, index) in expressInfo.TraceList" :key="index" class="timeline-item">
                                <div class="timeline-dot" :class="{ active: index === 0 }"></div>
                                <div class="timeline-content">
                                    <div class="timeline-text">{{ item.Text }}</div>
                                    <div class="timeline-time">{{ formatTime(item.Time) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="no-data">暂无物流信息</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';

export default {
    name: 'AdmissionResult',
    data() {
        return {
            loading: false,
            result: null,
            expressDialogVisible: false,
            expressInfo: null,
            loadingExpress: false,
            telDialogVisible: false,
            telInput: '',
            isValid: false
        };
    },
    mounted() {
        document.title = '武汉职业技术大学录取系统';
        this.loadResult();
    },
    methods: {
        loadResult() {
            this.loading = true;

            var storedResult = sessionStorage.getItem('admission_result');
            if (storedResult) {
                try {
                    this.result = JSON.parse(storedResult);
                    this.loading = false;
                    sessionStorage.removeItem('admission_result');
                    return;
                } catch (e) {
                    sessionStorage.removeItem('admission_result');
                }
            }

            var ksh = this.$route.query.ksh;
            var nf = '';
            var yxdm = '';
            var q = this.$route.query.q || '';
            if (q) {
                try {
                    q = q.replace(/-/g, '+').replace(/_/g, '/');
                    var padding = q.length % 4;
                    if (padding > 0) {
                        q += '='.repeat(4 - padding);
                    }
                    var decoded = atob(q);
                    var parts = decoded.split(' ');
                    var decodedNf = parts.length >= 1 ? parts[0] : '';
                    var decodedYxdm = parts.length >= 2 ? parts[1] : '';
                    
                    if (decodedNf === '2026' && decodedYxdm === '1001') {
                        nf = decodedNf;
                        yxdm = decodedYxdm;
                        this.isValid = true;
                    } else {
                        nf = '';
                        yxdm = '';
                        this.isValid = false;
                    }
                } catch (e) {
                    nf = '';
                    yxdm = '';
                    this.isValid = false;
                }
            } else {
                this.isValid = false;
            }

            if (this.isValid && ksh) {
                var api_name = '/Public/GetAdmissionInfoByKsh';
                var url = TYBM_Env.GetApiUrl(api_name) + '?ksh=' + encodeURIComponent(ksh);
                if (nf) url += '&nf=' + encodeURIComponent(nf);
                if (yxdm) url += '&yxdm=' + encodeURIComponent(yxdm);

                TYBM_Tools.AxiosGetEx(this, api_name, url, { loading: false })
                    .then(result => {
                        this.result = result.data;
                    })
                    .catch(() => {
                        this.result = null;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.result = null;
                this.loading = false;
            }
        },
        queryExpress() {
            if (!this.result.G_EMSNO) {
                this.$message.warning('该考生未设置快递单号');
                return;
            }

            this.telInput = '';
            this.telDialogVisible = true;
        },
        confirmTelInput() {
            var tel = this.telInput.trim();
            if (!/^\d{4}$/.test(tel)) {
                this.$message.warning('请输入4位数字');
                return;
            }

            this.telDialogVisible = false;
            this.expressInfo = null;
            this.expressDialogVisible = true;
            this.loadingExpress = true;

            var api_name = '/Public/GetExpressInfoByEms';
            var url = TYBM_Env.GetApiUrl(api_name) + '?emsNo=' + encodeURIComponent(this.result.G_EMSNO) + '&tel=' + encodeURIComponent(tel);

            TYBM_Tools.AxiosGetEx(this, api_name, url, { loading: false })
                .then(result => {
                    this.expressInfo = result.data;
                })
                .catch(() => {
                    this.$message.error('查询物流信息失败');
                })
                .finally(() => {
                    this.loadingExpress = false;
                });
        },
        closeTelDialog() {
            this.telDialogVisible = false;
            this.telInput = '';
        },
        closeExpressDialog() {
            this.expressDialogVisible = false;
            this.expressInfo = null;
        },
        goBack() {
            var url = '/Public/AdmissionQuery';
            var q = this.$route.query.q || '';
            if (q) {
                url += '?q=' + encodeURIComponent(q);
            }
            this.$router.push(url);
        },
        getStatusText(status) {
            const statusMap = {
                'SIGN': '已签收',
                'TRANSPORT': '运输中',
                'ACCEPT': '已揽收',
                'FAILED': '投递失败'
            };
            return statusMap[status] || '未知';
        },
        formatTime(timeStr) {
            if (!timeStr) return '';
            return timeStr;
        },
        formatScore(score) {
            if (score === null || score === undefined || score === '') return '';
            var num = parseFloat(score);
            if (isNaN(num)) return score;
            return num.toFixed(2);
        }
    }
};
</script>

<style>
body {
    background: #fff !important;
    margin: 0;
    padding: 0;
}

#app {
    background: #fff !important;
}
</style>

<style scoped>
.admission-result-container {
    min-height: 100vh;
    background: #fff;
    font-family: 'Microsoft YaHei', sans-serif;
}

.main-content {
    max-width: 600px;
    margin: 40px auto;
    padding: 0 24px;
}

.title {
    text-align: center;
    font-size: 28px;
    color: #333;
    margin-bottom: 28px;
    font-weight: bold;
    letter-spacing: 2px;
    border-bottom: none !important;
    background: transparent !important;
    padding-top: 0 !important;
}

.loading {
    text-align: center;
    padding: 60px;
    color: #999;
    font-size: 16px;
}

.result-section {
    margin-top: 20px;
}

.result-card {
    background: #fff;
    padding: 36px;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    border: 1px solid #f0f0f0;
}

.result-row {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px dashed #e8e8e8;
}

.result-row:last-of-type {
    border-bottom: none;
}

.result-row .label {
    width: 120px;
    color: #888;
    font-size: 15px;
    font-weight: 500;
}

.result-row .value {
    flex: 1;
    color: #333;
    font-size: 15px;
    font-weight: 500;
}

.result-row .value.underline {
    text-decoration: underline;
    text-decoration-color: #f5a623;
    text-underline-offset: 4px;
}

.express-link {
    flex: 1;
    color: #666;
    font-size: 15px;
    cursor: pointer;
    font-weight: 500;
    transition: color 0.3s;
}

.express-link:hover {
    color: #333;
    text-decoration: underline;
}

.admission-table {
    margin-top: 28px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.admission-table table {
    width: 100%;
    border-collapse: collapse;
}

.admission-table th {
    background: linear-gradient(135deg, #1a56c9 0%, #2c7ae0 100%);
    padding: 14px;
    text-align: center;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    border-bottom: none;
}

.admission-table td {
    padding: 20px;
    text-align: center;
    color: #333;
    font-size: 15px;
    background: #fff;
}

.admission-table tbody tr {
    transition: background 0.3s;
}

.admission-table tbody tr:hover {
    background: #f8f9fc;
}

.back-btn-container {
    margin-top: 36px;
    text-align: center;
}

.back-btn {
    padding: 14px 56px;
    background: linear-gradient(135deg, #f5a623 0%, #f7b84e 100%);
    color: #fff;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 16px rgba(245, 166, 35, 0.3);
}

.back-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(245, 166, 35, 0.4);
}

.not-found-section {
    background: #fff;
    padding: 50px;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    text-align: center;
}

.not-found-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto 24px;
    background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    color: #f56c6c;
}

.not-found-section h3 {
    font-size: 22px;
    color: #333;
    margin-bottom: 14px;
    font-weight: 600;
}

.not-found-section p {
    font-size: 15px;
    color: #999;
    margin-bottom: 30px;
}

.express-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.express-dialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
}

.express-dialog-content {
    position: relative;
    width: 520px;
    max-height: 75vh;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.3s ease;
}

@keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}

.dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: #f5f5f5;
    border-bottom: 1px solid #ddd;
}

.dialog-header h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
    font-weight: 600;
}

.close-btn {
    font-size: 28px;
    color: #999;
    cursor: pointer;
    line-height: 1;
    transition: color 0.3s;
}

.close-btn:hover {
    color: #333;
}

.dialog-body {
    padding: 24px;
    max-height: 55vh;
    overflow-y: auto;
}

.tel-input-section {
    text-align: center;
}

.tel-hint {
    color: #888;
    font-size: 14px;
    margin-bottom: 20px;
    line-height: 1.6;
}

.tel-input {
    width: 200px;
    margin: 0 auto;
}

.tel-input .el-input__inner {
    height: 48px;
    font-size: 20px;
    text-align: center;
    letter-spacing: 8px;
    border-radius: 10px;
    border: 2px solid #e8e8e8;
    transition: all 0.3s;
}

.tel-input .el-input__inner:focus {
    border-color: #f5a623;
    box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.1);
}

.dialog-actions {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    gap: 16px;
}

.cancel-btn {
    padding: 12px 32px;
    background: #f5f5f5;
    color: #666;
    border: none;
    border-radius: 25px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
}

.cancel-btn:hover {
    background: #eee;
}

.confirm-btn {
    padding: 12px 48px;
    background: linear-gradient(135deg, #f5a623 0%, #f7b84e 100%);
    color: #fff;
    border: none;
    border-radius: 25px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 12px rgba(245, 166, 35, 0.3);
}

.confirm-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(245, 166, 35, 0.4);
}

.ems-no {
    font-size: 16px;
    color: #333;
    margin-bottom: 18px;
    font-weight: 500;
}

.express-status {
    display: inline-block;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 24px;
}

.express-status.SIGN {
    background: linear-gradient(135deg, #f0f9eb 0%, #e1f3d8 100%);
    color: #67c23a;
}

.express-status.TRANSPORT {
    background: linear-gradient(135deg, #ecf5ff 0%, #dbeafe 100%);
    color: #409eff;
}

.express-status.ACCEPT {
    background: linear-gradient(135deg, #f4f4f5 0%, #e9e9eb 100%);
    color: #909399;
}

.express-status.FAILED {
    background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
    color: #f56c6c;
}

.express-timeline {
    position: relative;
}

.express-timeline::before {
    content: '';
    position: absolute;
    left: 11px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(180deg, #f5a623 0%, #e4e7ed 100%);
}

.timeline-item {
    position: relative;
    padding-left: 40px;
    padding-bottom: 24px;
}

.timeline-item:last-child {
    padding-bottom: 0;
}

.timeline-dot {
    position: absolute;
    left: 0;
    top: 6px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #e4e7ed;
    border: 3px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
}

.timeline-dot.active {
    background: #f5a623;
    box-shadow: 0 0 0 4px rgba(245, 166, 35, 0.2);
}

.timeline-content {
    background: #f8fafc;
    padding: 16px;
    border-radius: 10px;
    border-left: 4px solid #f5a623;
}

.timeline-text {
    color: #333;
    font-size: 14px;
    margin-bottom: 6px;
    line-height: 1.6;
}

.timeline-time {
    color: #999;
    font-size: 12px;
}

.no-data {
    text-align: center;
    padding: 50px;
    color: #999;
    font-size: 14px;
}

.invalid-access {
    background: #fff;
    padding: 50px;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    text-align: center;
}

.invalid-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto 24px;
    background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    color: #f56c6c;
}

.invalid-access h3 {
    font-size: 22px;
    color: #333;
    margin-bottom: 14px;
    font-weight: 600;
}

.invalid-access p {
    font-size: 15px;
    color: #999;
}
</style>
